/**
 * TemplateController
 * Responsible for selecting available Communications for the context
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

angular.module('flsControllers').controller('TemplateController', ['$scope','$window','Template', function($scope, $window, Template){
  // Define Context
  $scope.context_type = '';
  $scope.context_id = '';

  // List templates
  $scope.templates = {};
}]);
